module.exports = __webpack_public_path__ + "img/5-2.4dec729c.svg";